import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {
    GetWarehousesParams,
    WarehousesGetByCityIdResponseT,
    WarehousesGetListResponseT,
} from '../types/warehouses.types'

export class WarehousesRepository {
    getWarehouse(city_id: number): Promise<AxiosResponse<WarehousesGetByCityIdResponseT>> {
        return http.get(`/cabinet/api/warehouses/info/${city_id}`)
    }

    getWarehouses(
        params?: GetWarehousesParams
    ): Promise<AxiosResponse<WarehousesGetListResponseT>> {
        return http.get('/cabinet/api/warehouses', { params })
    }
}
